// Retorna true se a conta do usuário expirou. Lê de useSessionStore.
// Usado pelos players pra abortar tentativa de stream com mensagem clara
// (em vez de "Não foi possível reproduzir o conteúdo" genérico).

import { useSessionStore } from '../store'

export function useAccountExpired(): boolean {
  const accountExpiresAt = useSessionStore((s) => s.accountExpiresAt)
  if (!accountExpiresAt) return false
  return accountExpiresAt < Math.floor(Date.now() / 1000)
}
